"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clear = void 0; /// <reference types="localforage" />

var localforage_1 = __importDefault(require("localforage"));
/** storage is a wrapper for localforage/IndexedDB */


var storage = localforage_1.default.createInstance({
  name: "corona-api-unit",
  description: "The Corona API unit database"
});

function clear() {
  return storage.clear();
}

exports.clear = clear;
exports.default = storage;